module.exports = __webpack_public_path__ + "assets/img/user2.b2434bb9.png";